import { AppDispatch, CombinedStates } from 'core/types';
import { useDispatch, useSelector } from 'react-redux';
import { downloadNotificationFile, fetchUnreadNotifications, markAllNotificationsAsReadServer, markNotificationAsReadServer } from './notificationApi';
import { markAllNotificationsAsRead, markNotificationAsRead } from './notificationSlice';
import { Notification } from './types';

const useNotifications = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { isFetching, notifications } = useSelector((state: CombinedStates) => state.notification);

    const fetchAllNotifications = () => {
        dispatch(fetchUnreadNotifications());
    };

    const markAsRead = (id: string) => {
        // pre-emptively mark as read
        dispatch(markNotificationAsRead(id));
        // then dispatch to server
        dispatch(markNotificationAsReadServer(id));
    };

    const markAllAsRead = () => {
        // pre-emptively mark as read
        dispatch(markAllNotificationsAsRead());
        // then dispatch to server
        dispatch(markAllNotificationsAsReadServer());
    };

    const downloadFile = (notif: Notification) => {
        dispatch(downloadNotificationFile(notif));
    };

    return {
        isFetching,
        notifications,
        fetchAllNotifications,
        markAsRead,
        markAllAsRead,
        downloadFile,
    };
};

export default useNotifications;
